<!-- =========================================================================================
    File Name: NotAuthorized.vue
    Description: Not Authorized Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="../../assets/images/pages/not-authorized.png" alt="graphic-not-authorized" class="mx-auto mb-4">
            <h1 class="mb-12 text-5xl d-theme-heading-color">Mobile Device Detected</h1>
            <p class="mb-16 d-theme-text-inverse">Unfortunately the content you tried to access cannot be viewed on a mobile device (smartphone or tablet).<br>Please log in again from a computer (laptop or desktop-computer) and try again.</p>
            <vs-button v-if="$route.params.isStudent" size="large" to="/menu">Back to Menu</vs-button>
            <vs-button v-else size="large" @click="closeTab">Close</vs-button>
        </div>
    </div>
</template>

<script>
export default {
  methods: {
    closeTab() {
      this.close();
    },
    close() {
      window.open('','_self').close()
    }
  }
};
</script>